import { type Theme } from '@logto/schemas';
import classNames from 'classnames';

import styles from './index.module.scss';

type Props = {
  readonly className?: string;
  readonly theme: Theme;
};

const LogtoSignature = ({ className, theme }: Props) => (
  <div className={classNames(styles.signature, className)} data-theme={theme}>
    <span className={styles.text}>Powered by Logto</span>
  </div>
);

export default LogtoSignature;
